// Path: frontend/src/lib/api/bgVideo.ts
// Description: Background video API module

import { api } from './core';

// ==========================================
// 📚 Type Definitions (Background Video)
// ==========================================

export interface BgVideoItem {
  id: number;
  sys: string;
  page: string;
  index: number;
  url: string;
}

export interface BgVideoListResponse {
  sys: string;
  page: string;
  total: number;
  videos: BgVideoItem[];
}

// ==========================================
// 🎬 Background Video API
// ==========================================

export const getBgVideoList = (sys: string, page: string) => 
  api.get<BgVideoListResponse>(`/bg-video/list`, { params: { sys, page } });

export const getBgVideoUrls = (sys: string, page: string) => 
  api.get<string[]>(`/bg-video/urls`, { params: { sys, page } });
